import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

import { appRoutes } from './app.routes';
import { provideSessionBootstrap } from './core/auth';
import { provideBusinessSettingsBootstrap } from './core/settings';
import { defaultAppConfig, APP_CONFIG } from './core/config';
import { authInterceptor } from './core/http';
import { AppErrorHandler } from './core/errors/app-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideSessionBootstrap(),
    provideBusinessSettingsBootstrap(),
    {
      provide: APP_CONFIG,
      useValue: defaultAppConfig
    },
    {
      // Factory (not useClass): AppErrorHandler takes an optional non-DI
      // test-seam parameter, so Angular must not reflect its constructor.
      provide: ErrorHandler,
      useFactory: () => new AppErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]
};
